import * as Sentry from "@sentry/react";
import { SeverityLevel } from "@sentry/react";

const error = (message: string, event?: any) => {
  Sentry.captureMessage(message, "error" as SeverityLevel);
};

const warning = (message: string, event?: any) => {
  Sentry.captureMessage(message, "warning" as SeverityLevel);
};

const info = (message: string, event?: any) => {
  Sentry.captureMessage(message, "info" as SeverityLevel);
};

const log = {
  error,
  warning,
  info,
};

export default log;
